export default "__VITE_ASSET__CvCSrqgi__"